const lazyloadPageheader = () => {
    const pageheader = document.querySelector('.pageheader'); // Use querySelector to find the first element with the class "pageheader"

    if (!pageheader) {
        return; // Exit if no element is found
    }

    const image = pageheader.getAttribute('data-background'); // Use getAttribute to get the data attribute value
    pageheader.style.backgroundImage = `url(${image})`; // Set the backgroundImage style property
};

lazyloadPageheader();

var jQuery = $
import slick from '../../node_modules/slick-carousel/slick/slick.min.js';
import Shop from './shop';
import Schatten from './schatten';
import Blog from './blog';

window.shop = Shop;
window.schatten = Schatten;
window.blog = Blog;

window.app = {
    /**
     * Initialize.
     */
    init() {

        // Initialze shop
        Shop.init();

        // Initialze schatten
        Schatten.init();

        // Initialze blog
        //Blog.init();

        // Register event listeners
        $('a[href="#"]').on('click', $.proxy(this.scrollToAnchor, this));
        $(window).on('scroll', $.proxy(this.windowScrollHandler, this));
        $('.hamburger').on('click', $.proxy(this.toggleHamburgerMenu, this));

        // Initialize sliders
        this.initSliders();


        // Initialize counters
        this.initCounters();

        // Show more function
        // this.showMoreBlogs();

        // Toggle rotate cards
        this.toggleRotateCard();

        // FAQ Toggle
        this.faqToggle();

        // Open Shopping cart sidebar
        $(".action-bag, .close-sidebar, .sidebar-overlay, .open-shopping-bag").on('click', $.proxy(this.openSidebar, this));

        // Select payment method
        this.selectPaymentMethod();

        // Cart quantity price
        this.quantityPrice();

        // Hide checkout email input
        this.HideEmail();

        // Search Toggle
        this.searchToggle();
    },

    /**
     * Scroll to anchor.
     *
     * @param {event} e
     */
    scrollToAnchor(e) {
        // $('html, body').animate({scrollTop: $(e.currentTarget).offset().top - 50}, 800, () => window.location.hash = hash);
    },

    /**
     * Handles the scroll event.
     *
     * @param {event} e
     */
    windowScrollHandler(e) {
        $('header').toggleClass('scrolled', $(window).scrollTop() > 200);
    },

    /**
     * Open hamburger menu.
     *
     * @param {event} e
     */
    toggleHamburgerMenu(e) {
        $(e.currentTarget).toggleClass('is-active');
        $("nav.navigation").toggleClass('visible');
    },

    /**
     * Rotate cards.
     *
     */
    toggleRotateCard() {
        $(".main-container.front").on('click', function (e) {
            $(".images.card").addClass('rotate');
        });
    },

    /**
     * Init sliders.
     *
     */
    initSliders() {
        if ($('.footer__slider .swiper .feed').length) {
            $('.footer__slider .swiper .feed #sb_instagram #sbi_images').slick({
                autoplay: true,
                autoplaySpeed: 3000,
                slidesToShow: 2,
                centerMode: true,
                mobileFirst: true,
                infinite: true,
                arrows: false,
                centerPadding: '7.5px',
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1279,
                        settings: {
                            slidesToShow: 4,
                            centerPadding: '15px',
                        }
                    },
                ]
            });
        }
        ;

        if ($(window).width() < 1280) {
            $('.footer__slider .swiper .feed #sb_instagram #sbi_images').slick('slickGoTo', 1, false);
        } else {
            $('.footer__slider .swiper .feed #sb_instagram #sbi_images').slick('slickGoTo', 2, false);
        }

        // Config single-schatten slider
        if ($('.single-schatten .slider .images').length) {
            $('.single-schatten .slider .images').slick({
                autoplay: false, autoplaySpeed: 3000, slidesToShow: 1, dots: true, arrows: true
            });
        }
        ;

        // Config single-post slider
        if ($('.single-post .slider .images').length) {
            $('.single-post .slider .images').slick({
                autoplay: false, autoplaySpeed: 3000, slidesToShow: 1, dots: true, arrows: true
            });
        }
        ;
    },

    /**
     * Show more function
     *
     */
    // showMoreBlogs() {
    //     $(".loadmoreblogs").on('click', function (e) {
    //         e.preventDefault();
    //         $(this).parent().parent().parent().find($('.col:hidden')).slice(0, 3).slideDown().css('display', 'flex');
    //     });
    // },

    /** Counters - Amount */
    initCounters() {
        $('body').on('click', '.counter .fa-plus, .counter .fa-minus', function () {
            var qty = $(this).closest('.counter').find('.qty');
            var val = parseFloat(qty.val());
            var max = parseFloat(qty.attr('max'));
            var min = parseFloat(qty.attr('min'));
            var step = parseFloat(qty.attr('step'));
            var hash = $(this).parents('.bag-item').attr('id');

            if ($(this).is('.plus')) {
                if (max && (max <= val)) {
                    qty.val(max);
                } else {
                    qty.val(val + step);
                }
            } else {
                // if (min >= val) {
                //     qty.val(min);
                // } else

                if (val > 0) {
                    qty.val(val - step);
                }
            }

            if (hash) {
                $.ajax({
                    method: 'POST',
                    url: '/wp-admin/admin-ajax.php',
                    data: {
                        action: 'change_quantity',
                        hash: hash,
                        quantity: $(qty).val()
                    },
                    success: function (res) {
                        $('.bag-items .holder').html(res.html);
                        $('.bag-counter').text(res.count);
                        $('.totals-list .total-price').html(res.price);
                        $('.totals-list .shipping-price').html(res.shipping);
                    }
                });
            }
        });
        $('body').on('click', '.input-number-group .fa-plus, .input-number-group .fa-minus', function () {
            var qty = $(this).closest('.input-number-group').find('.qty');
            var val = parseFloat(qty.val());
            var max = parseFloat(qty.attr('max'));
            var min = parseFloat(qty.attr('min'));
            var step = parseFloat(qty.attr('step'));
            var hash = $(this).parents('.bag-item').attr('id');

            if ($(this).is('.fa-plus')) {
                if (max && (max <= val)) {
                    qty.val(max);
                } else {
                    qty.val(val + step);
                }
            } else {
                // if (min >= val) {
                //     qty.val(min);
                // } else
                if (val > 0) {
                    qty.val(val - step);
                }
            }
        });
    },

    /** Open Shopping cart sidebar */
    openSidebar(e) {
        if (e) e.preventDefault();
        $(".shopping-bag-sidebar").toggleClass('is-opened');
        $(".sidebar-overlay").toggleClass('is-opened');
        $("body").toggleClass('is-locked');
    },

    /** Toggle hidden form items */
    toggleHiddenFormItems() {


        $(".toggle-label").on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass("is-opened");
            $(".more-payment-options").slideToggle();
        });

    },

    /** Select payment method */
    selectPaymentMethod() {
        $('.payment-methods .payment-method input:radio').change(function () {
            $('.payment-methods .payment-method').removeClass('is-selected');
            $(this).closest('.payment-method').addClass('is-selected');
        });
    },

    /** Quantity change in cart */
    quantityPrice() {
        jQuery(".qtyval").bind('change keyup mouseup paste', function () {
            var qty = jQuery(this).val();
            var key = jQuery(this).attr("key");
            var product_price = jQuery(this).attr("product_price");
            jQuery('.quantity' + key).html(qty);
            if (qty == 0) {
                jQuery('#' + key).hide();
            }
            var tot = product_price * qty;
            jQuery('#' + key + ' .priceintable').html('<span class="woocommerce-Price-currencySymbol">€</span> ' + parseFloat(tot).toFixed(2));
            if (ajaxRequest) { // if any previous ajaxRequest is running, abort
                ajaxRequest.abort();
            }
            var baseUrl = document.location.origin;
            var ajaxRequest = jQuery.ajax({
                type: "POST",
                url: baseUrl + '/wp-content/themes/designated-child/action.php',
                data: { pageajax: true, qty: qty, key: key },
                success: function (data) {
                    var result = data.split('::');
                    jQuery('span.shopping_bag_items_number').html(result[0]);
                    jQuery('.total-price').html(result[1]);
                }
            });
        });
        jQuery(".ddd").on("click", function () {
            var $button = jQuery(this);
            var oldValue = $button.closest('.counter').find("input.quntity-input").val();
            if ($button.text() == "+") {
                var newVal = parseFloat(oldValue) + 1;
            } else {
                // Don't allow decrementing below zero
                if (oldValue > 0) {
                    var newVal = parseFloat(oldValue) - 1;
                } else {
                    newVal = 0;
                }
            }
            $button.closest('.counter').find("input.quntity-input").val(newVal);
            $button.closest('.counter').find("input.quntity-input").change();
        });

        function del_pro(x) {
            jQuery("#" + x + " input.quntity-input").val(0);
            jQuery("#" + x + " input.quntity-input").change();
        }
    },

    /** Hide checkout email input */
    HideEmail() {
        //When auto input is active
        $('#account_username').val($('#billing_email').val());
        //When input is changed
        $('#billing_email').change(function () {
            $('#account_username').val($(this).val());
        });
    },

    /** FAQ Toggle */
    faqToggle() {
        $('.faq-question').click(function (e) {
            e.preventDefault();
            var $this = $(this);

            if ($this.hasClass('show')) {
                $this.removeClass('show');
                $this.parent().removeClass('dropshadow');
                $this.next().removeClass('show');
                $this.next().slideUp(350);
            } else {
                $this.toggleClass('show');
                $this.parent().toggleClass('dropshadow');
                $this.next().toggleClass('show');
                $this.next().slideToggle(350);
            }
        });
    },

    /** Search Toggle */
    searchToggle() {
        $("body:not(.search-results) header .search").click(function (e) {
            e.preventDefault();
            var $this = $(this);
            let $searchbar = $(".searchbar");

            if ($this.hasClass('is-active')) {
                $this.removeClass('is-active');
                $searchbar.removeClass('is-opened');
            } else {
                $this.toggleClass('is-active');
                $searchbar.toggleClass('is-opened');
            }
        });
    },

};

$(document).ready($.proxy(app.init, app));

$(document).ready(function () {

    $(".card").click(function () {
        $(this).toggleClass("rotate");
    });

    $(".filters .term.active").hover(
        function () {
            $(".filters .term.active .far").removeClass('fa-check-square').addClass('fa-minus-square');
        }, function () {
            $(".filters .term.active .far").addClass('fa-check-square').removeClass('fa-minus-square');
        },
    );

    // Smooth scroll for hash links
    $(function () {
        if (window.location.hash) {
            $('html,body').animate({
                scrollTop: $(window.location.hash).offset().top - 60
            }, 900, 'swing');
        }
    });


});








